import { useMemo } from 'react';
import { useCampfireQuery } from '../../../../../../../../global/network/useCampfireQuery';
import { KeyLink, KeyLinkType } from '../../../dashboard-widget-setting/dashboard-widget-model';
import { KEY_LINK_OPTIONS_QUERY } from './key-links.gql';
import { GetKeyLinkOptions } from './__generated__/GetKeyLinkOptions';

export interface KeyLinkOption {
  type: KeyLinkType;
  id: string | null;
  label: string;
  url: string;
  isActive: boolean;
  slug?: string;
  description?: string | null;
  image?: string | null;
}

export const keyLinkKey = ({ type, id }: KeyLink) => `${type}:${id ?? ''}`;

export const useKeyLinkOptions = () => {
  const { data, loading } = useCampfireQuery<GetKeyLinkOptions, {}>(KEY_LINK_OPTIONS_QUERY);
  const { origin } = window.location;

  const options = useMemo<KeyLinkOption[]>(() => {
    const forms = (data?.vm.forms ?? []).map((form) => ({
      type: 'form' as const,
      id: form.formId,
      label: form.title,
      url: `${origin}/form/${form.formId}`,
      isActive: true,
    }));
    const funnels = (data?.vm.funnels ?? []).map((funnel) => ({
      type: 'funnel' as const,
      id: funnel.funnelId,
      label: funnel.name,
      url: `${origin}/apply/${funnel.slug}`,
      isActive: funnel.isActive,
      slug: funnel.slug,
      description: funnel.description,
      image: funnel.image,
    }));
    return [
      { type: 'apply' as const, id: null, label: 'Apply to volunteer', url: `${origin}/apply`, isActive: true },
      ...forms,
      ...funnels,
    ];
  }, [data, origin]);

  return { options, orgLogo: data?.orgLogo ?? null, loading };
};
